<template>
    <nav>
      <vue-paginate
        v-model="page"
        container-class="pagination justify-content-center"
        :page-count="totalPage"
        prev-text="<<"
        next-text=">>"
        page-class="page-item"
        page-link-class="page-link"
        prev-link-class="page-link"
        next-link-class="page-link"
        :click-handler="callback"
      ></vue-paginate>
    </nav>
  </template>
  
  <script>
  import { mapGetters, mapMutations } from 'vuex';
  
  export default {
    name: 'Paginate',
    props: ['totalPage', 'callback'],
    data() {
      return {
        page: 1,
      };
    },
    computed: {
      ...mapGetters({
        currentPage: 'getPage',
      }),
    },
    methods: {
      ...mapMutations({
        setPage: 'setPage',
      }),
    },
    watch: {
      currentPage(value) {
        this.page = value;
      },
    },
    mounted() {
      this.page = this.currentPage;
    },
  };
  </script>
  
  <style scoped>
  >>> .pagination {
    display: flex;
    gap: 15px;
    align-items: center;
    margin: 0;
    padding: 0;
  }

  >>> .page-item {
    list-style: none;
  }

  >>> .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 32px;
    height: 32px;
    padding: 6px 10px;
    border: none;
    border-radius: 6px;
    background-color: #ffffff;
    color: #787878;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  }

  >>> .page-link:hover {
    background-color: #f0f0f0;
    color: #006C6B;
  }

  >>> .page-item.active .page-link {
    background-color: #006C6B;
    color: #ffffff;
    font-weight: 600;
    box-shadow: 0px 2px 6px rgba(0, 108, 107, 0.3);
  }

  >>> .page-item.disabled .page-link {
    background-color: #f5f5f5;
    color: #cccccc;
    cursor: not-allowed;
    box-shadow: none;
  }

  >>> .page-item.disabled .page-link:hover {
    background-color: #f5f5f5;
    color: #cccccc;
  }

  /* Prev/Next buttons styling */
  >>> .page-item:first-child .page-link,
  >>> .page-item:last-child .page-link {
    font-weight: 600;
    color: #006C6B;
  }

  >>> .page-item:first-child .page-link:hover,
  >>> .page-item:last-child .page-link:hover {
    background-color: #E7F6F6;
  }

  @media (max-width: 768px) {
    >>> .page-link {
      min-width: 28px;
      height: 28px;
      padding: 4px 8px;
      font-size: 12px;
    }

    >>> .pagination {
      gap: 8px;
    }
  }
  </style>
  